import gql from 'graphql-tag';

import { HierarchySearchItemFields } from '../fragments/search';

export const hierarchySearch = gql`
  query hierarchySearch(
    $name: String
    $username: String
    $account_search_query: String
    $location: LocationRadiusSearchInput
    $start_date: DateTimeTZ
    $end_date: DateTimeTZ
    $limit: Int = 30
    $offset: Int = 0
    $album_type: AlbumTypesType = null
  ) {
    hierarchySearch(
      name: $name
      location: $location
      username: $username
      account_search_query: $account_search_query
      start_date: $start_date
      end_date: $end_date
      slice: { limit: $limit, offset: $offset }
      album_type: $album_type
    ) {
      total
      records {
        ...HierarchySearchItemFields
      }
    }
  }
  ${HierarchySearchItemFields}
`;
